// extracted by mini-css-extract-plugin
export var icon = "_wo-0";